import React from 'react';
import MailIconSubscribe from './assets/AnimatedSubscribe';
import MailIconDoi from './assets/AnimatedDOI';
import MailIconSuccess from './assets/AnimatedSuccessfull';
var MailIcon = function (_a) {
    var type = _a.type;
    switch (type) {
        case 'subscribe':
            return React.createElement(MailIconSubscribe, null);
        case 'doi':
            return React.createElement(MailIconDoi, null);
        case 'success':
            return React.createElement(MailIconSuccess, null);
        default:
            return React.createElement(React.Fragment, null);
    }
};
export default MailIcon;
//# sourceMappingURL=index.js.map